"use client";


import { VisitorInfo } from '@/shared/types/chat-widget-visitor';

export function identifyVisitor(organizationId: string): VisitorInfo {
    const storageKey = `flowapt_visitor_${organizationId}`;
    const contactStorageKey = `flowapt_contact_${organizationId}`;

    // Try to get existing visitor info from localStorage
    let visitorInfo = localStorage.getItem(storageKey);

    // Get contact ID if it exists
    const contactId = localStorage.getItem(contactStorageKey);

    if (!visitorInfo) {
        // Create new visitor info if none exists
        // Use contact ID if available, otherwise use a temporary ID
        visitorInfo = JSON.stringify({
            visitorId: contactId,
            firstSeen: new Date().toISOString(),
            lastSeen: new Date().toISOString(),
        });
        localStorage.setItem(storageKey, visitorInfo);
    } else {
        // Update existing visitor's last seen time and create new session
        const info = JSON.parse(visitorInfo);

        // If contact ID is available, update the visitorId to match the contactId
        if (contactId && info.visitorId !== contactId) {
            info.visitorId = contactId;
        }

        info.lastSeen = new Date().toISOString();
        localStorage.setItem(storageKey, JSON.stringify(info));
    }

    return JSON.parse(visitorInfo);
}

// Function to save contact ID to localStorage
export function saveContactId(organizationId: string, contactId: string): void {
    const contactStorageKey = `flowapt_contact_${organizationId}`;
    localStorage.setItem(contactStorageKey, contactId);

    // Also update the visitor info to use this contactId
    const storageKey = `flowapt_visitor_${organizationId}`;
    const visitorInfo = localStorage.getItem(storageKey);

    if (visitorInfo) {
        const info = JSON.parse(visitorInfo);
        info.visitorId = contactId;
        localStorage.setItem(storageKey, JSON.stringify(info));
    }
} 